<template>
   <div class="referal_reports">
      <div class="filter">
         <Form 
            class_binding="row justify-content-md-center" 
            :ref="Model.forms.filter_coupons.name" 
            :forms="Model.forms.filter_coupons.forms" 
            :form_data="Model.forms.filter_coupons.data"
            @button-click="filterCoupons({ref: $refs[Model.forms.filter_coupons.name], id: $route.params.id})"
         />
      </div>
      
      <!-- Referal Report -->
      <div class="dotted-border" v-if="referal_reports.length === 0">
         <div class="row justify-content-md-center">
            <div class="col-12 col-md-11 col-lg-10 col-xl-9 action-card">
               <div class="btn btn-transparent btn-primary btn-round"><div :class="Model.tables.referal_reports.props.icon"></div></div>
               <div class="title">{{Model.tables.referal_reports.props.title}}</div>
               <div class="subtitle">
                  No Referals found! Select a date to query.
               </div>
            </div>
         </div>
      </div>
      <Table v-bind="Model.tables.referal_reports.props" :data="referal_reports" @on-action="handleActions" v-if="referal_reports.length > 0">
         <template slot-scope="{ row }" slot="redemption_code">
            <strong class="tx-small" v-if="row.redemption_code">{{ row.redemption_code }}</strong>
            <strong class="tx-small" v-else>-</strong>
         </template>
         <template slot-scope="{ row }" slot="redeemed_at">
            <strong class="tx-small">{{ dayjs(row.redeemed_at).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="is_redeemed">
            <strong class="t6 tx-success" v-if="row.is_redeemed">REDEEMED</strong>
            <strong class="t6 tx-danger" v-else> NOT REDEEMED</strong>
         </template>
         <template slot-scope="{ row }" slot="discount">
            <strong class="t5">{{utils.numberWithCommas(row.discount)}}</strong>
         </template>
      </Table>

      <!-- Promotional Coupons -->
      <div class="dotted-border" v-if="promotion__redemptions.length === 0">
         <div class="row justify-content-md-center">
            <div class="col-12 col-md-11 col-lg-10 col-xl-9 action-card">
               <div class="btn btn-transparent btn-primary btn-round"><div :class="Model.tables.promotion_coupon_redemption.props.icon"></div></div>
               <div class="title">{{Model.tables.promotion_coupon_redemption.props.title}}</div>
               <div class="subtitle">
                  No Coupons found! Query to Continue.
               </div>
            </div>
         </div>
      </div>
      <Table v-bind="Model.tables.promotion_coupon_redemption.props" :data="promotion__redemptions" @on-action="handleActions" v-if="promotion__redemptions.length > 0">
         <template slot-scope="{ row }" slot="redemption_code">
            <strong class="tx-small" v-if="row.redemption_code">{{ row.redemption_code }}</strong>
            <strong class="tx-small" v-else>-</strong>
         </template>
         <template slot-scope="{ row }" slot="redeemed_at">
            <strong class="tx-small">{{ dayjs(row.redeemed_at).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="discount">
            <strong class="t5">{{utils.numberWithCommas(row.discount)}}</strong>
         </template>
      </Table>

      <!-- Rule Based Coupons -->
      <div class="dotted-border" v-if="coupons.length === 0">
         <div class="row justify-content-md-center">
            <div class="col-12 col-md-11 col-lg-10 col-xl-9 action-card">
               <div class="btn btn-transparent btn-primary btn-round"><div :class="Model.tables.coupon.props.icon"></div></div>
               <div class="title">{{Model.tables.coupon.props.title}}</div>
               <div class="subtitle">
                  No Coupons found! Select a date to query.
               </div>
            </div>
         </div>
      </div>
      <Table v-bind="Model.tables.coupon.props" :data="coupons" @on-action="handleActions" v-if="coupons.length > 0">
         <template slot-scope="{ row }" slot="valid_until">
            <strong class="tx-small">{{ dayjs(row.valid_until).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="redemption_code">
            <strong class="tx-small" v-if="row.redemption_code">{{ row.redemption_code }}</strong>
            <strong class="tx-small" v-else>-</strong>
         </template>
         <template slot-scope="{ row }" slot="redeemed_at">
            <strong class="tx-small">{{ dayjs(row.redeemed_at).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="is_redeemed">
            <strong class="t6 tx-success" v-if="row.is_redeemed">REDEEMED</strong>
            <strong class="t6 tx-danger" v-else> NOT REDEEMED</strong>
         </template>
         <template slot-scope="{ row }" slot="discount">
            <strong class="t5">{{utils.numberWithCommas(row.discount)}}</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import referal_reports from "./referal_reports.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('referal_reports')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('referal_reports',referal_reports,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         dayjs,
         utils,
      };
   },
   computed: {
      ...mapGetters([
         'Model',
         'referal_reports',
         'promotion__redemptions',
         'coupons',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'filterCoupons',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('referal_reports',referal_reports,this.$store)
      await this.fetchData({id: this.$route.params.id})
   }
}
</script>

<style lang="scss">
   .referal_reports{
      .ivu-table-wrapper {
         margin: 20px 0 0 0;
      }
      .bottom-content{
         margin: 0 0 90px 0;
      }
   }
</style>